export const RoleSelect = ({ testid, value, onChange }) => (
  <label className="block"><span className="field-label">Role</span>
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className="inp">
      <option value="User">User</option>
      <option value="Admin">Admin</option>
    </select>
  </label>
);

export const RepSelect = ({ testid, reps, value, onChange }) => (
  <label className="block"><span className="field-label">Linked rep</span>
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} className="inp">
      <option value="">No linked rep</option>
      {reps.filter((r) => r.active || r.id === value).map((r) => (
        <option key={r.id} value={r.id}>{`${r.name} (${r.role})${r.active ? "" : " inactive"}`}</option>
      ))}
    </select>
  </label>
);
